module.exports = __webpack_public_path__ + "static/trLogoWhite-8853f69cde58db55c787dde1bc2a040a.png";